import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'recharts';

export function PieChartLabelComponent({
  x,
  y,
  percent,
  name,
}) {
  return (
    <g>
      <Text
        x={x}
        y={y}
        fill="black"
        textAnchor="middle"
        className="label"
      >
        {name}
      </Text>
      <Text
        x={x}
        y={y + 12}
        fill="black"
        textAnchor="middle"
        className="label"
        fontWeight="bold"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </Text>
    </g>
  );
}

PieChartLabelComponent.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  percent: PropTypes.number,
  name: PropTypes.string,
};

export default PieChartLabelComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/PieChart/PieChartLabel.js